/* eslint-disable camelcase */
import { formatPrice } from '@westwing/appshell-formatting-helpers';
import { CartAPIFullData } from '../types/oneCartAPI';
import { EventData } from '../WWEvents';
import { getCartProducts } from '../helpers/cartV2.helpers';

export const SHOP_CART_URL = '/shop/cart/';

export const calculateSecondsLeft = (inputTime: string): number => {
    const inputDate = new Date(inputTime);
    if (Number.isNaN(inputDate.getTime())) {
        return 0;
    }

    const currentTime = new Date();
    const timeDifference = inputDate.getTime() - currentTime.getTime();
    if (timeDifference < 0) {
        return 0;
    }

    return Math.floor(timeDifference / 1000);
};

export const transformOneCartResponseToMiniCartData = (
    oneCartResponse: CartAPIFullData['data'],
    country: string
): EventData['ADDED_TO_CART'] => ({
    seconds_left: calculateSecondsLeft(oneCartResponse.cart.expiry || ''),
    total: oneCartResponse.cart.summary.quantity,
    expired: false,
    products: getCartProducts(oneCartResponse, country),
    totalPrice: formatPrice(
        country,
        oneCartResponse.cart.summary.grandTotal.currency,
        oneCartResponse.cart.summary.grandTotal.value / 100
    ),
    delivery_times_changed: false,
});

export const isClubHeaderInBella = (location?: Location): boolean => {
    if (!location) {
        return false;
    }
    const params = new URLSearchParams(location.search);
    return params.get('businessOrigin') === 'club' && location.pathname === SHOP_CART_URL;
};
